import { Component, Input } from '@angular/core';
import { NavController, InfiniteScroll, App } from 'ionic-angular';
import { EventProvider, EventComplex, EventDetailsModel, EventTievts, EventSearchModel, Pager } from '../../providers/event/event';
import { ResultProvider } from '../../providers/result/result';
import { LoaderProvider } from '../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { EventTabsPage } from '../../pages/event/details/event-tabs/event-tabs';
import { ResultRanglistPage } from '../../pages/results/result-ranglist/result-ranglist';
import { ResultEventDetailsPage } from '../../pages/results/result-event-details/result-event-details';

/**
 * Generated class for the ImageContainerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
    selector: 'menu-layer-total',
    templateUrl: 'menu-layer-total.html'
})
export class MenuLayerTotalComponent {
    currentPage = 1;
    EVENTS_PER_PAGE = 10;

    @Input("eventType")
    eventType: string = "";

    @Input("eventArea")
    eventArea: string = "";

    @Input("type")
    type: string = "Events";

    events = [];

    searchModel: EventSearchModel = {
        cid: '',
        dur: '',
        str: '',
        umkr: '',
        zip: ''
    };

    savedSearch: Pager;

    constructor(public navCtrl: NavController,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public loadingCtrl: LoaderProvider,
        public translate: TranslateService,
        private app: App) {
    }

    getEventStatus(event: EventTievts) {
        if (typeof event === "undefined") return "";
        let status = event.eventStatus;
        if (status.toUpperCase().includes("C")) return this.translate.instant('EVENT_CANCELLED');
        else if (status.toUpperCase().includes("N")) return this.translate.instant('NOT_CONFIRMED');
        else return "";
    }

    ngAfterViewInit() {
        var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.searchModel.limit = 10 + '';
        this.searchModel.page = 1 + '';
        this.searchModel.start = 1 + '';
        let type = this.resultService.getResultTypeAPIName(this.eventType, this.type);
        this.eventService.getEventSimple(type, this.eventArea, this.searchModel).then(events => {
            let unique = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);

            if (this.eventArea.toUpperCase().includes("VIR")) this.eventArea = this.translate.instant("CATEGORY_VIRTUAL");
            this.events = Object.assign([], unique);

            this.savedSearch = {
                page: this.searchModel.page,
                limit: this.searchModel.limit,
                start: this.searchModel.start
            };

            this.loadNextPage(null);

            loader.dismiss();
        });
    }

    arrayOf(n?: number) {
        return this.events.slice(0, this.EVENTS_PER_PAGE * this.currentPage);
    }

    // loadNextPage(event: InfiniteScroll) {
    //     this.currentPage++;
    //     event.complete();
    // }

    onEventLoad(event) {
        if (this.type === "Events") this.openEventDetails(event);
        else this.onShowRangList(event);
    }

    openEventDetails(_event) {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.eventService.getEventId(_event.eventName, _event.ort, _event.dateFormatted, _event.cid).then(id => {
            if (id == -1) { loader.dismiss(); return; };

            this.eventService.getEventDetails(id).then((event: EventDetailsModel) => {

                if (event.name.length < 1) {
                    this.openEventDetails(_event);
                    loader.dismiss();
                } else {
                    (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
                }
            });
        })
    }

    loadNextPage(paginator) {
        this.searchModel.limit = (Number(this.searchModel.limit) + 10) + '';

        this.eventService.getEventSimple(this.resultService.getResultTypeAPIName(this.eventType, this.type), this.eventArea, this.searchModel).then(events => {
            let unique = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
            this.events = unique;
            if (paginator) paginator.complete();
        });
    }


    onShowRangList(event) {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.eventService.getEventId(event.eventName, event.ort, event.dateFormatted, event.cid).then(id => {

            let searchModel = { eid: '' + id, ename: '' + event.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };

            (this.app.getRootNav() as NavController).push(ResultEventDetailsPage, { eventDetails: event, search: searchModel })
                .then(() => loader.dismiss());
        });
    }
}



// WEBPACK FOOTER //
// /src/components/menu-layer-total/menu-layer-total.ts